import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { RouterProvider } from '@tanstack/react-router';
import { trpc } from '@/trpc';
import { router } from '@/router';
import { API_BASE_URL } from '@/lib/constants';
import '@/styles/globals.css';

export function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  const [trpcClient] = useState(() =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (trpc as any).createClient({
      links: [
        httpBatchLink({
          url: `${API_BASE_URL}/trpc`,
        }),
      ],
    }),
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const TrpcProvider = (trpc as any).Provider;

  return (
    <TrpcProvider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </TrpcProvider>
  );
}
